import apiClient from './client'
import type { ApiResponse } from '@portal/types'
import type { CreatePaymentInput } from '@portal/schemas'

export interface PaymentListItem {
  id: string
  paymentMode: string
  creditAccount: string
  creditIfsc: string
  payeeName: string
  amount: number
  currency: string
  remarks?: string
  status: string
  externalReferenceId?: string
  vendor?: { id: string; name: string } | null
  creator: { id: string; name: string }
  transactions: Array<{ iciciUtr?: string | null; iciciStatus?: string | null }>
  createdAt: string
  updatedAt: string
}

export interface PaymentDetail extends PaymentListItem {
  debitAccount: string
  workflowRequired: boolean
  vendorId?: string | null
  approver?: { id: string; name: string; email: string } | null
  rejectedReason?: string | null
  approvalLogs: Array<{
    id: string
    action: string
    actor: { id: string; name: string; email: string }
    reason?: string | null
    createdAt: string
  }>
}

export interface PaymentListResponse {
  items: PaymentListItem[]
  total: number
  page: number
  limit: number
}

export interface PaymentStatusResponse {
  paymentId: string
  status: string
  uniqueId?: string | null
  utr?: string | null
  iciciStatus?: string | null
  updatedAt: string
}

export interface ListPaymentsParams {
  page?: number
  limit?: number
  search?: string
  status?: string
  fromDate?: string
  toDate?: string
}

export const paymentsApi = {
  create: (data: CreatePaymentInput) =>
    apiClient.post('/api/payments', data) as unknown as Promise<ApiResponse<PaymentDetail>>,

  submit: (id: string) =>
    apiClient.post(`/api/payments/${id}/submit`) as unknown as Promise<ApiResponse<PaymentDetail>>,

  list: (params?: ListPaymentsParams) =>
    apiClient.get('/api/payments', { params }) as unknown as Promise<ApiResponse<PaymentListResponse>>,

  getById: (id: string) =>
    apiClient.get(`/api/payments/${id}`) as unknown as Promise<ApiResponse<PaymentDetail>>,

  getStatus: (id: string) =>
    apiClient.get(`/api/payments/${id}/status`) as unknown as Promise<ApiResponse<PaymentStatusResponse>>,
}
